/*
  CentyCanada — Gift a Toy Box JavaScript (FIXED v2)
  File: assets/cc-gift-box.js
*/
(function () {
  'use strict';

  var BOX = [];
  var MAX_ITEMS = 5;

  var grid, slots, progressFill, progressMsg, pricing, originalPriceEl,
      discountPctEl, discountAmtEl, totalPriceEl, savingsBannerEl,
      savingsAmtEl, cartBtn, minNote, giftToggle, giftToggleWrap,
      searchInput, tierEls, markerEls;

  function init() {
    grid          = document.getElementById('ccGbProductGrid');
    slots         = document.getElementById('ccGbBoxSlots');
    progressFill  = document.getElementById('ccGbProgressFill');
    progressMsg   = document.getElementById('ccGbProgressMsg');
    pricing       = document.getElementById('ccGbPricing');
    originalPriceEl = document.getElementById('ccGbOriginalPrice');
    discountPctEl = document.getElementById('ccGbDiscountPct');
    discountAmtEl = document.getElementById('ccGbDiscountAmt');
    totalPriceEl  = document.getElementById('ccGbTotalPrice');
    savingsBannerEl = document.getElementById('ccGbSavingsBanner');
    savingsAmtEl  = document.getElementById('ccGbSavingsAmt');
    cartBtn       = document.getElementById('ccGbCartBtn');
    minNote       = document.getElementById('ccGbMinNote');
    giftToggle    = document.getElementById('ccGbGiftWrap');
    giftToggleWrap = document.getElementById('ccGbGiftToggle');
    searchInput   = document.getElementById('ccGbSearch');
    tierEls       = document.querySelectorAll('.cc-gb-tier');
    markerEls     = document.querySelectorAll('.cc-gb-progress-marker');

    if (!grid) return;

    initItemClicks();
    initSlotRemove();
    initSearch();
    initCartButton();
    initPremadeButtons();
  }

  /* ── ITEM CLICK / SELECT ───────────────────────────────── */
  function initItemClicks() {
    grid.addEventListener('click', function (e) {
      // Prevent default link behavior
      e.preventDefault();
      e.stopPropagation();

      var item = e.target.closest('.cc-gb-item');
      if (!item) return;

      var variantId = item.dataset.variantId;
      if (!variantId) return;

      var idx = findInBox(variantId);

      if (idx !== -1) {
        removeFromBox(idx);
        item.classList.remove('selected');
      } else {
        if (BOX.length >= MAX_ITEMS) {
          shakeBtn();
          return;
        }
        BOX.push({
          variantId: variantId,
          productId: item.dataset.productId,
          title: item.dataset.title,
          price: parseInt(item.dataset.price, 10) || 0,
          image: item.dataset.image || ''
        });
        item.classList.add('selected');
      }

      updateUI();
    });
  }

  function findInBox(variantId) {
    for (var i = 0; i < BOX.length; i++) {
      if (BOX[i].variantId === variantId) return i;
    }
    return -1;
  }

  function removeFromBox(idx) {
    var removed = BOX.splice(idx, 1)[0];
    if (removed) {
      var gridItem = grid.querySelector('[data-variant-id="' + removed.variantId + '"]');
      if (gridItem) gridItem.classList.remove('selected');
    }
  }

  /* ── SLOT CLICK REMOVE ─────────────────────────────────── */
  function initSlotRemove() {
    if (!slots) return;
    slots.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cc-gb-slot-remove');
      if (!removeBtn) return;

      var slot = removeBtn.closest('.cc-gb-slot');
      var slotIdx = parseInt(slot.dataset.slot, 10);
      if (slotIdx < BOX.length) {
        removeFromBox(slotIdx);
        updateUI();
      }
    });
  }

  /* ── UPDATE ALL UI ─────────────────────────────────────── */
  function updateUI() {
    updateSlots();
    updateProgress();
    updateTiers();
    updatePricing();
    updateButton();
  }

  function updateSlots() {
    if (!slots) return;
    var slotEls = slots.querySelectorAll('.cc-gb-slot');
    if (!slotEls.length) return;

    slotEls.forEach(function (slot, i) {
      // Clear slot first
      slot.innerHTML = '';

      if (i < BOX.length) {
        slot.className = 'cc-gb-slot filled';
        slot.dataset.slot = i;

        if (BOX[i].image) {
          var img = document.createElement('img');
          img.src = BOX[i].image;
          img.alt = BOX[i].title || '';
          slot.appendChild(img);
        } else {
          var num = document.createElement('span');
          num.className = 'cc-gb-slot-num';
          num.style.color = '#1E3A2F';
          num.style.opacity = '1';
          num.style.fontWeight = '500';
          num.textContent = (i + 1);
          slot.appendChild(num);
        }

        var removeEl = document.createElement('span');
        removeEl.className = 'cc-gb-slot-remove';
        removeEl.innerHTML = '&times;';
        removeEl.title = 'Remove ' + (BOX[i].title || '');
        slot.appendChild(removeEl);
      } else {
        slot.className = 'cc-gb-slot empty';
        slot.dataset.slot = i;
        var numEl = document.createElement('span');
        numEl.className = 'cc-gb-slot-num';
        numEl.textContent = (i + 1);
        slot.appendChild(numEl);
      }
    });
  }

  function updateProgress() {
    if (!progressFill || !progressMsg) return;
    var pct = (BOX.length / MAX_ITEMS) * 100;
    progressFill.style.width = pct + '%';

    markerEls.forEach(function (m) {
      var at = parseInt(m.dataset.at, 10);
      m.classList.toggle('reached', pct >= at);
    });

    var count = BOX.length;
    if (count === 0) {
      progressMsg.textContent = 'Add 3 toys to unlock 10% off';
      progressMsg.style.color = '#BA7517';
    } else if (count < 3) {
      var need = 3 - count;
      progressMsg.textContent = 'Add ' + need + ' more toy' + (need > 1 ? 's' : '') + ' to unlock 10% off';
      progressMsg.style.color = '#BA7517';
    } else if (count === 3) {
      progressMsg.textContent = '10% off unlocked! Add 1 more for 15% off';
      progressMsg.style.color = '#2D6B1E';
    } else if (count === 4) {
      progressMsg.textContent = '15% off unlocked! Add 1 more for 20% off';
      progressMsg.style.color = '#2D6B1E';
    } else {
      progressMsg.textContent = 'Maximum discount unlocked — 20% off!';
      progressMsg.style.color = '#2D6B1E';
    }
  }

  function updateTiers() {
    var count = BOX.length;
    tierEls.forEach(function (el) {
      var tierMin = parseInt(el.dataset.tier, 10);
      el.classList.remove('active', 'reached');
      if (count >= tierMin) el.classList.add('reached');
      if (count > 0 && getDiscountTier(count) === tierMin) el.classList.add('active');
    });
  }

  function getDiscountPct(count) {
    if (count >= 5) return 20;
    if (count >= 4) return 15;
    if (count >= 3) return 10;
    return 0;
  }

  function getDiscountTier(count) {
    if (count >= 5) return 5;
    if (count >= 4) return 4;
    if (count >= 3) return 3;
    return 0;
  }

  function updatePricing() {
    if (!pricing) return;
    var count = BOX.length;
    var pct = getDiscountPct(count);

    if (count === 0) {
      pricing.style.display = 'none';
      if (giftToggleWrap) giftToggleWrap.style.display = 'none';
      return;
    }

    pricing.style.display = 'block';
    if (giftToggleWrap) giftToggleWrap.style.display = (count >= 3) ? 'flex' : 'none';

    var total = 0;
    BOX.forEach(function (item) { total += item.price; });

    var discountAmount = Math.round(total * (pct / 100));
    var finalPrice = total - discountAmount;

    if (originalPriceEl) originalPriceEl.textContent = formatMoney(total);
    if (discountPctEl) discountPctEl.textContent = pct;
    if (discountAmtEl) discountAmtEl.textContent = '-' + formatMoney(discountAmount);
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(finalPrice);

    if (pct > 0 && savingsBannerEl) {
      savingsBannerEl.style.display = 'block';
      if (savingsAmtEl) savingsAmtEl.textContent = formatMoney(discountAmount);
    } else if (savingsBannerEl) {
      savingsBannerEl.style.display = 'none';
    }

    if (originalPriceEl) originalPriceEl.style.textDecoration = pct > 0 ? 'line-through' : 'none';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateButton() {
    if (!cartBtn) return;
    var count = BOX.length;
    var canBuy = count >= 3;
    cartBtn.disabled = !canBuy;

    if (canBuy) {
      var pct = getDiscountPct(count);
      cartBtn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>' +
        ' Add ' + count + '-toy box to cart' + (pct > 0 ? ' (' + pct + '% off)' : '');
      if (minNote) minNote.style.display = 'none';
    } else {
      cartBtn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>' +
        ' Add Box to Cart';
      if (minNote) {
        minNote.style.display = 'block';
        minNote.textContent = 'Select at least ' + (3 - count) + ' more toy' + ((3 - count) > 1 ? 's' : '') + ' to build your box';
      }
    }
  }

  function shakeBtn() {
    if (!cartBtn) return;
    cartBtn.style.animation = 'none';
    void cartBtn.offsetWidth;
    cartBtn.style.animation = 'cc-gb-shake 0.4s ease';
    setTimeout(function () { cartBtn.style.animation = ''; }, 500);
  }

  /* ── SEARCH ────────────────────────────────────────────── */
  function initSearch() {
    if (!searchInput) return;
    searchInput.addEventListener('input', function () {
      var q = this.value.toLowerCase().trim();
      var items = grid.querySelectorAll('.cc-gb-item');
      items.forEach(function (item) {
        var title = (item.dataset.title || '').toLowerCase();
        item.style.display = (q === '' || title.indexOf(q) !== -1) ? '' : 'none';
      });
    });
  }

  /* ── ADD TO CART (Custom Box) ───────────────────────────── */
  function initCartButton() {
    if (!cartBtn) return;
    cartBtn.addEventListener('click', function () {
      if (BOX.length < 3) return;

      var items = BOX.map(function (item) {
        return { id: parseInt(item.variantId, 10), quantity: 1 };
      });

      // Add gift wrap if checked
      if (giftToggle && giftToggle.checked && giftToggleWrap) {
        var wrapId = giftToggleWrap.dataset.wrapVariantId;
        if (wrapId) {
          items.push({ id: parseInt(wrapId, 10), quantity: 1 });
        }
      }

      var original = cartBtn.innerHTML;
      cartBtn.innerHTML = 'Adding to cart...';
      cartBtn.disabled = true;
      cartBtn.style.opacity = '0.7';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            cartBtn.innerHTML = data.description || 'Error — try again';
            cartBtn.style.background = '#A32D2D';
          } else {
            cartBtn.innerHTML = 'Added to cart!';
            cartBtn.style.background = '#2D6B1E';
            refreshCartCount();
          }
          setTimeout(function () {
            cartBtn.innerHTML = original;
            cartBtn.disabled = false;
            cartBtn.style.opacity = '';
            cartBtn.style.background = '';
            BOX = [];
            grid.querySelectorAll('.cc-gb-item.selected').forEach(function (el) {
              el.classList.remove('selected');
            });
            updateUI();
          }, 2500);
        })
        .catch(function () {
          cartBtn.innerHTML = 'Error — try again';
          cartBtn.disabled = false;
          cartBtn.style.opacity = '';
          setTimeout(function () { cartBtn.innerHTML = original; updateUI(); }, 2000);
        });
    });
  }

  /* ── PRE-MADE BOX BUTTONS ──────────────────────────────── */
  function initPremadeButtons() {
    document.querySelectorAll('.cc-gb-premade-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = this.dataset.variantId;
        if (!variantId) {
          // It's a link, let it navigate
          var href = this.getAttribute('href');
          if (href) window.location.href = href;
          return;
        }

        var original = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;
        this.style.opacity = '0.7';
        var btnRef = this;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              btnRef.textContent = data.description || 'Error';
              btnRef.style.background = '#A32D2D';
            } else {
              btnRef.textContent = 'Added!';
              btnRef.style.background = '#2D6B1E';
              refreshCartCount();
            }
            setTimeout(function () {
              btnRef.textContent = original;
              btnRef.disabled = false;
              btnRef.style.opacity = '';
              btnRef.style.background = '';
            }, 2000);
          })
          .catch(function () {
            btnRef.textContent = 'Try again';
            btnRef.disabled = false;
            btnRef.style.opacity = '';
            setTimeout(function () { btnRef.textContent = original; }, 2000);
          });
      });
    });
  }

  /* ── REFRESH CART COUNT ────────────────────────────────── */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden), [data-cart-count]')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      });
  }

  /* ── SHAKE ANIMATION ───────────────────────────────────── */
  var style = document.createElement('style');
  style.textContent = '@keyframes cc-gb-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-6px)}40%{transform:translateX(6px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}}';
  document.head.appendChild(style);

  /* ── INIT ──────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

})();
